import { PowerOutage } from 'seacube-backend/src/api/client';

import { store } from './store';

export const setPowerOutagesMinDuration = (duration: number) => {
  store.powerOutages.minDuration = duration;
  setFilteredPowerOutages();
};

export const setPowerOutagesMinDeviation = (deviation: number) => {
  store.powerOutages.minDeviation = deviation;
  setFilteredPowerOutages();
};

export const setRawPowerOutages = (powerOutages: PowerOutage[]) => {
  store.powerOutages.raw = powerOutages;
  setFilteredPowerOutages();
};

export const setFilteredPowerOutages = () => {
  store.powerOutages.filtered = store.powerOutages.raw.filter(
    (p: PowerOutage) => {
      const start = new Date(p.start_datetime).getTime();
      const end = new Date(p.end_datetime).getTime();
      return (
        (end - start) / (1000 * 60 * 60) >= store.powerOutages.minDuration &&
        Math.abs(p.deviation) >= store.powerOutages.minDeviation
      );
    },
  );
};
